<template>
  <div>
    <!-- 快速报价 -->
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> / <a>关于汇利兴</a>
        </div>
        <div class="page-center-box w-100">
          <div class="ksbj-box w-100">
            <div class="box-info1 w-100">— 价格咨询 —</div>
            <div class="box-info2 w-100 between-center">
              <form action="" class="pull-left" method="post">
                <div class="box1 w-100">
                  <span><i>*</i> 用户名：</span>
                  <input
                    v-model="formData.name"
                    type="text"
                    class="text"
                    name=""
                    id=""
                    value=""
                    placeholder="请输入用户名"
                  />
                </div>
                <div class="box1 w-100">
                  <span><i>*</i> 联系电话：</span>
                  <input
                    v-model="formData.phone"
                    type="text"
                    class="text"
                    name=""
                    id=""
                    value=""
                    placeholder="请输入联系电话"
                  />
                </div>
                <div class="box1 w-100" style="display: flex">
                  <span><i>*</i> 需求描述：</span>
                  <!-- <input
                    v-model="formData.demand"
                    type="text"
                    class="text"
                    name=""
                    id=""
                    value=""
                    placeholder="请输入您的需求"
                  /> -->
                  <el-input
                    style="width: 82%"
                    type="textarea"
                    :rows="10"
                    placeholder="请输入您的需求"
                    v-model="formData.demand"
                  >
                  </el-input>
                </div>
                <input class="btns" value="提交" @click="undeveloped" />
              </form>
              <div class="pull-right">
                <div class="between-center">
                  <img src="../../assets/images/icon_20.png" />
                  <div>
                    <p>在线客服</p>
                    <p>
                      <!-- QQ号：829218298192（<a @click="undeveloped">立即联系</a>） -->
                      QQ号：2881860556（<a @click="undeveloped">立即联系</a>）
                    </p>
                  </div>
                </div>
                <div class="between-center">
                  <img src="../../assets/images/icon_21.png" />
                  <div>
                    <p>电话客服</p>
                    <!-- <p>电话：0769-23888888</p> -->
                    <p>电话：023-68617887</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { message } from '../../common/common.js'
import { addOrderInquiry } from '../../common/http.js';
export default {
  data () {
    return {
      formData: {
        name: "",
        phone: "",
        demand: "",
      }
    }
  },
  computed: {
    ...mapGetters(['getDemand'])
  },
  mounted () {
    const demand = sessionStorage.getItem("demand")
      if (demand) {
      this.formData.demand = demand
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (Object.keys(userInfo).length > 0) {
      this.formData.phone = userInfo.phone;
      this.formData.name = userInfo.userName;
    }
  },
  methods: {
    undeveloped () {
      const { name, phone, demand } = this.formData;
      if (name === '') {
        message({
          message: '请输入用户名',
          type: 'error'
        })
        return;
      }
      if (phone == '') {
        message({
          message: '请输入联系电话',
          type: 'error'
        })
        return;
      } else {
        let REG = /^1[3-9]\d{9}$/;
        if (!REG.test(phone)) {
          message({
            message: '联系电话格式错误',
            type: 'error'
          })
          return;
        }
      }
      if (demand == '') {
        message({
          message: '请输入您的需求',
          type: 'error'
        })
        return;
      }
      sessionStorage.setItem("demand", this.formData.demand)
      this.$store.commit("SET_DEMAND", this.formData.demand)
      addOrderInquiry({ ...this.formData }).then(res => {
        if (res.result) {
          message({
            message: res.msg,
            type: 'success'
          })
          this.$router.push("/meInquiry")
          sessionStorage.removeItem("demand")
        } else {
          message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/quickQuotation/quickQuotation.vue